import useBindActionCreators from 'common/hooks/useBindActionCreators';

import { applicationOperations } from '../store';

export const useApplicationOperations = (): typeof applicationOperations => {
  const bindedActions = useBindActionCreators(applicationOperations);
  return bindedActions;
};
